import React from "react";
import { Link } from "react-router-dom";

const SalesOverview = ({ heading, link, icon, number, parcentage }) => {
  return (
    <div className="bg-white p-1 rounded w-full lg:min-w-[190px] lg:max-w-[320px] shadow-xl">
      <div className="flex flex-row justify-between items-center">
        <Link to={link} className="text-sm hover:underline">
          {heading}
        </Link>
        <div>{icon}</div>
      </div>
      <h1 className="text-xl font-bold my-1">{number}</h1>
      <div className="flex flex-row justify-between items-center">
        <h1 className="text-sm font-semibold  italic">+{parcentage}%</h1>
        <h1 className="text-sm">Since last month</h1>
      </div>
    </div>
  );
};

export default SalesOverview;
